import axios from 'axios'

const baseURL = `${process.env.GATSBY_NETLIFY_API_URL}/captcha_verification`

export const verifyCaptchaToken = async (token) => {
  const payload = new FormData()
  payload.set('token', token)
  const { data } = await axios.post(baseURL, payload)

  return data
}
